'use client';

import { useContext } from 'react';
import Link from 'next/link';
import LandQuantityInput from '../molecules/landQuantityInput';
import { LandPurchaseContext } from '../../contexts/land-purchase-context';
import PurchaseSummaryModal from './purchaseSummaryModal';
import { ModalContext } from '../../contexts/modal-provider';
import { LandTiers } from '../../services/AggregateLand/AggregateLandService';
import CryptoMintBtn from './cryptoMintBtn';
import { useUserInfoContext } from '../../contexts/userinfo-context';
import { ShibInputRadio } from '@shibaone/shibuikit/dist/src/components/molecules/ShibInputRadio';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { useLocale } from 'next-intl';

const QuickBuyCard = () => {
    const {
        landType,
        resetPurchaseSummary,
        updateLandType,
        totalEth,
        landQuantity,
        updatePurchaseSuccessfully,
    } = useContext(LandPurchaseContext);
    const { modalState, openModal } = useContext(ModalContext);
    const totalPrice: number = Number(totalEth);
    const { openConnectModal, connectModalOpen } = useConnectModal();
    const { refreshLands } = useUserInfoContext();
    const { address } = useAccount()
    const currentLocale = useLocale();

    const startPayment = () => {
        if (!address) {
            openConnectModal?.();
        } else {
            resetPurchaseSummary();
            openModal({ type: 'PURCHASE_SUMMARY_MODAL' });
        }
    };

    const openOrderSucceed = async (value: any): Promise<void> => {
        refreshLands();
        updatePurchaseSuccessfully(value);
    };

    return (
        <>
            <div className="font-sora m-auto flex flex-col items-center justify-center gap-6 rounded-[39px] border bg-black bg-opacity-70 shadow-lg border border-[#ffff] backdrop-blur-md p-6 sm:w-[400px] lg:w-[650px] md:w-[650px]">
                <div className="flex w-full flex-row items-center justify-between gap-4">
                    <div className="w-auto text-left text-2xl font-normal leading-loose text-[#EC5B04]">
                        Quick Buy
                    </div>
                    <Link
                        href={`/${currentLocale}/map`}
                        className="flex gap-2 text-right text-sm font-semibold leading-tight text-[#EC5B04]"
                    >
                        Visit land map
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.5 5.62518V12.5002M12.5 7.50018V14.3752M12.9193 17.2906L16.9818 15.2593C17.2994 15.1005 17.5 14.7759 17.5 14.4208V4.01709C17.5 3.32017 16.7666 2.86689 16.1432 3.17856L12.9193 4.79055C12.6553 4.92252 12.3447 4.92252 12.0807 4.79055L7.91926 2.70981C7.65533 2.57785 7.34467 2.57785 7.08074 2.70981L3.01824 4.74106C2.70063 4.89987 2.5 5.22449 2.5 5.57959V15.9833C2.5 16.6802 3.23342 17.1335 3.85676 16.8218L7.08074 15.2098C7.34467 15.0778 7.65533 15.0778 7.91926 15.2098L12.0807 17.2906C12.3447 17.4225 12.6553 17.4225 12.9193 17.2906Z"
                                stroke="#EF6402"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link>
                </div>
                <div className="flex flex-col items-center justify-center gap-8 self-stretch border-b border-t border-white py-6">
                    <div className="flex flex-row items-center justify-between gap-3.5 self-stretch">
                        <div className="w-full text-left text-base font-semibold leading-normal text-white my-2">
                            Land Type
                        </div>
                        <div className="flex flex-col md:flex-row items-start md:items-center lg:space-x-12 md:space-x-4 md:space-y-0 sm:space-x-0 sm:space-y-6">
                            {/* <div className="flex min-w-max items-center justify-start gap-1 rounded-lg w-full md:w-auto">
                                <ShibInputRadio
                                    name="landType"
                                    defaultChecked={landType === LandTiers.tier1}
                                    onChange={() => updateLandType(LandTiers.tier1)}
                                />
                                <span className="mt-1 self-center text-sm text-slate-50">Diamond Teeth</span>
                            </div>
                            <div className="flex min-w-max items-center justify-start gap-1 rounded-lg w-full md:w-auto">
                                <ShibInputRadio
                                    name="landType"
                                    defaultChecked={landType === LandTiers.tier2}
                                    onChange={() => updateLandType(LandTiers.tier2)}
                                />
                                <span className="mt-1 self-center text-sm text-slate-50">Platinum Paw</span>
                            </div> */}
                            <div className="flex min-w-max items-center justify-start gap-1 rounded-lg w-full md:w-auto">
                                <ShibInputRadio
                                    name="landType"
                                    defaultChecked={landType === LandTiers.tier3}
                                    onChange={() => updateLandType(LandTiers.tier3)}
                                />
                                <span className="mt-1 text-sm font-normal leading-none text-slate-50">
                                    Golden Tail
                                </span>
                            </div>
                            <div className="flex min-w-max items-center justify-start gap-1 rounded-lg w-full md:w-auto">
                                <ShibInputRadio
                                    name="landType"
                                    defaultChecked={landType === LandTiers.tier4}
                                    onChange={() => updateLandType(LandTiers.tier4)}
                                />
                                <span className="mt-1 self-center text-sm text-slate-50">Silver Fur</span>
                            </div>
                        </div>
                    </div>
                    <div className="flex w-full items-center justify-between gap-6">
                        <div className="text-base font-semibold leading-normal text-white">Quantity</div>
                        <div className="flex items-center justify-start gap-5 rounded-3xl">
                            <LandQuantityInput />
                        </div>
                    </div>

                    {/* <div className="flex w-full items-center justify-between gap-6">
                        <div className="text-base font-semibold leading-normal text-white">Total Due</div>
                        <div className="text-xl font-bold leading-7 text-neutral-50">
                            {totalPrice.toFixed(2)} <span className="text-orange-500">ETH</span>
                        </div>
                    </div> */}
                </div>
                <div className="flex flex-col items-center justify-center gap-4 self-stretch">
                    {/* <div className="w-full text-left text-base font-semibold leading-normal text-white">
                        Payment Options
                    </div> */}
                    <div className="flex flex-col items-start justify-start gap-7 self-stretch">
                        <div className="flex flex-col items-start justify-start gap-2 self-stretch">
                            {/* <button
                onClick={() => startPayment()}
                className="m-auto flex h-12 w-full items-center justify-center gap-3 rounded-3xl bg-orange-500 px-8 text-sm font-semibold text-white hover:bg-orange-600"
              >
                Pay with Credit Card
              </button> */}
                            <CryptoMintBtn
                                tier={landType as LandTiers}
                                quantity={landQuantity}
                                onOpen={openConnectModal}
                            />
                            <div className="text-sm text-slate-50 text-center w-full">*Click on the mint button to get accurate pricing.</div>
                        </div>
                    </div>
                </div>
            </div>
            {modalState.type === 'PURCHASE_SUMMARY_MODAL' && <PurchaseSummaryModal />}
        </>
    );
};

export default QuickBuyCard;
